import {
  BANK_DETAILS,
  PERSONAL_DETAILS,
  SUPERANNUATION,
  TAX_DETAILS,
  TFN_DECLARATION,
  WORK_RIGHTS_UK_FIELDS,
} from '@/core/field-names';
import { QUESTION_FIELD_TYPE } from '@/core/input-types/custom_questions';

export const FIELDS_TO_MASK = [
  PERSONAL_DETAILS.EMAIL,
  PERSONAL_DETAILS.PREFERRED_NAME,
  PERSONAL_DETAILS.EMERGENCY_CONTACT_NAME,
  PERSONAL_DETAILS.EMERGENCY_CONTACT_MOBILE,
  PERSONAL_DETAILS.EMERGENCY_CONTACT_RELATIONSHIP,
  BANK_DETAILS.ACCOUNT_NAME,
  BANK_DETAILS.ACCOUNT_NUMBER,
  TFN_DECLARATION.TFN,
  TFN_DECLARATION.NAME,
  SUPERANNUATION.NAME,
  SUPERANNUATION.TFN,
  SUPERANNUATION.MEMBER_NUMBER,
  SUPERANNUATION.SELF_MANAGED,
  SUPERANNUATION.SELF_MANAGED_FORM,
  TAX_DETAILS.NATIONAL_INSURANCE_NUMBER,
  WORK_RIGHTS_UK_FIELDS.SHARE_CODE,
  WORK_RIGHTS_UK_FIELDS.PASSPORT,
  WORK_RIGHTS_UK_FIELDS.BIRTH_CERTIFICATE,
  WORK_RIGHTS_UK_FIELDS.SUPPORTING_DOCUMENTS,
  QUESTION_FIELD_TYPE,
];

export function enableMask(field) {
  return (
    FIELDS_TO_MASK.includes(field.name) || FIELDS_TO_MASK.includes(field.type)
  );
}
